// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { AuthConfig } from "angular-oauth2-oidc";
import {Environment} from 'ngx-paf-common';

export const claimTypes = {
  email:"http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress",
  name:"http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name",
  identifier:"http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
}

export const authConfig:AuthConfig = {
  issuer:"https://auth-qas.paf.heiv.info",
  postLogoutRedirectUri: window.location.origin,
  redirectUri: window.location.origin + '/' + window.location.pathname.split('/')[1]  +'/login/callback',
  clientId: 'portail-fournisseurs-extranet',
  responseType: 'code',
  scope: 'openid profile extranet',
  showDebugInformation: true
}


export const pafEnvironment : Environment = {
  debug:  false,
  apiBaseUrl:  'https://api-qas.paf.heiv.info/api/',
  portalType:  'EXTRANET',
  oktaBaseUri:  '',
  production : false,
  authenticationType :  'extranet',
  logo: 'Logo_Equans.png',
  logoUrl:  'https://www.equans.fr',
  logoNgStyle :  {'height':'55px','object-fit':'contains'}
};

